<template>
  <div id="adminContainer">
    <div class="adminTitle">Admin Page</div>

    <div class="resultInput">
      <input type="text" placeholder="Result" v-model="resultToInput" @keypress="checkChar" />
      <div class="submitButton" @click="inputResult">Update Result</div>
    </div>

    <table>
      <thead>
        <tr>
          <th>Tanggal</th>
          <th>Bola 1</th>
          <th>Bola 2</th>
          <th>Bola 3</th>
          <th>Bola 4</th>
          <th>Bola 5</th>
          <th>Bola 6</th>
          <th>Additional</th>
          <th>Result</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(data, index) in resultData" :key="index">
          <td>{{ dateFormatter(data.date) }}</td>
          <td>{{ data.bolaSatu }}</td>
          <td>{{ data.bolaDua }}</td>
          <td>{{ data.bolaTiga }}</td>
          <td>{{ data.bolaEmpat }}</td>
          <td>{{ data.bolaLima }}</td>
          <td>{{ data.bolaEnam }}</td>
          <td>{{ data.additionalNumber }}</td>
          <td>{{ data.result }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = 'Admin Page - Bangkok Lotteries';
    this.getAllResults(this.pageLoaded);
    this.checkAuth();
  },

  methods: {
    async checkAuth() {
      try {
        const uri = '/api/checkAccessCode';
        const method = 'POST';

        const headers = {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        };

        const body = JSON.stringify({ code: localStorage.getItem('accessToken') });
        const response = await fetch(uri, { method, headers, body });
        const res = await response.json();
        if (!response.ok) throw new Error(res);
      } catch (error) {
        alert(`Sesi sudah berakhir. Silahkan login kembali.`);
        this.$router.push('/gogogo');
      }
    },

    async getAllResults() {
      try {
        const uri = '/api/allResults?page=1';
        const token = localStorage.getItem('accessToken');
        const headers = { Authorization: `Token ${token}` };
        const response = await fetch(uri, { headers });
        const res = await response.json();
        if (!response.ok) throw new Error(res.message);
        this.resultData = res;
        if (this.dateFormatter(res[0].date) == this.dateFormatter(new Date())) this.sudahInput = true;
      } catch (message) {
        alert(message || `Terjadi kesalahan.`);
      }
    },

    async inputResult() {
      try {
        if (this.buttonDisabled) throw new Error(`Sedang dalam proses. Sabar yak`);
        if (this.sudahInput) throw new Error(`Result hari ini sudah diinput.`);
        if (this.resultToInput.toString().length !== 4) throw new Error(`Result harus 4 angka`);
        const uri = '/api/inputResult';
        const method = 'POST';
        const token = localStorage.getItem('accessToken');

        const headers = {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`,
        };

        const body = JSON.stringify({
          result: this.resultToInput,
          date: `${this.getToday()}`,
        });

        const response = await fetch(uri, { method, headers, body });
        const res = await response.json();
        if (!response.ok) throw new Error(res.message);
        alert(res.message);
        this.getAllResults();
      } catch (message) {
        alert(message || `Terjadi kesalahan.`);
      }
    },

    getToday() {
      const hariIni = new Date();
      return `${hariIni.getFullYear()}-${hariIni.getMonth() + 1}-${hariIni.getDate()}`;
    },

    dateFormatter(date) {
      const dateObj = new Date(date);
      let dateDay = '';

      switch (dateObj.getDay()) {
        case 0:
          dateDay = 'Sunday';
          break;

        case 1:
          dateDay = 'Monday';
          break;

        case 2:
          dateDay = 'Tuesday';
          break;

        case 3:
          dateDay = 'Wednesday';
          break;

        case 4:
          dateDay = 'Thursday';
          break;

        case 5:
          dateDay = 'Friday';
          break;

        case 6:
          dateDay = 'Saturday';
          break;
      }

      let dateMonth = '';

      switch (dateObj.getMonth()) {
        case 0:
          dateMonth = 'January';
          break;

        case 1:
          dateMonth = 'February';
          break;

        case 2:
          dateMonth = 'March';
          break;

        case 3:
          dateMonth = 'April';
          break;

        case 4:
          dateMonth = 'May';
          break;

        case 5:
          dateMonth = 'June';
          break;

        case 6:
          dateMonth = 'Juli';
          break;

        case 7:
          dateMonth = 'August';
          break;

        case 8:
          dateMonth = 'September';
          break;

        case 9:
          dateMonth = 'October';
          break;

        case 10:
          dateMonth = 'November';
          break;

        case 11:
          dateMonth = 'December';
          break;
      }

      return `${dateDay}, ${dateObj.getDate()} ${dateMonth} ${dateObj.getFullYear()}`;
    },

    checkChar(e) {
      const allowed_condition = (e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode === 8;
      if (!allowed_condition) e.preventDefault();
    },
  },
  data() {
    return {
      resultData: [],
      resultToInput: '',
      buttonDisabled: false,
      sudahInput: false,
    };
  },
};
</script>

<style>
#adminContainer {
  background: url('../assets/backgroundFirstSection.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
  padding: 50px;
  box-sizing: border-box;
}

.adminTitle {
  font-size: 2em;
  font-weight: bold;
  color: var(--lightColor);
}

.resultInput {
  display: flex;
  justify-content: space-between;
  width: 350px;
  margin-top: 10px;
}

.submitButton {
  background-color: var(--darkColor);
  color: var(--lightColor);
  font-weight: bold;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
}

.submitButton:hover {
  background-color: rgba(116, 82, 77, 0.8);
}

.submitButton:active {
  background-color: rgba(116, 82, 77, 1);
}

.resultInput input {
  border: none;
  border-radius: 5px;
  flex-grow: 1;
  margin-right: 10px;
  padding: 10px 15px;
  outline: none;
}

#adminContainer table {
  border-radius: 15px;
  margin-top: 20px;
  overflow: hidden;
}

#adminContainer table thead tr th {
  padding: 12px 24px;
  background-color: var(--darkColor);
  color: var(--lightColor);
}

#adminContainer table tbody tr td {
  background-color: var(--lightColor);
  padding: 12px 24px;
  text-align: center;
}
</style>
